// eslint-disable-next-line no-unused-vars
import React from 'react';
import { IconMembership, dlsBrightBlue } from '@americanexpress/dls-react'; // eslint-disable-line no-unused-vars
import { routes } from '../../constants/paths';
import labels from '../../constants/labels';

export const manageContactActions = {
  updateContactInfo: {
    id: 'update-contact-info',
    heading: labels.CONTACT_INFO,
    icon: <IconMembership size="lg" theme={dlsBrightBlue} className="pad-1-t" />,
    primaryButtonLabel: labels.GET_STARTED,
    tertiaryButtonLabel: labels.LEARN_MORE,
    modalProp: {
      modalId: 'modal-update-contact-info',
      modalHeader: labels.CONTACT_INFO,
      modalBody: (
        <>
          <p>
            Click the button below to update contact information for yourself, any of your colleagues, or any
            distribution lists used to communicate with American Express. You can update name, email address,
            contact type, and contact description. The updating of contact information ensures communication
            between American Express and your organization for file transfer related issues and requests.
          </p>
          <br />
          <ul>
            <li>View the security standard informing this action</li>
            <li>View instructions on how to update the server password</li>
          </ul>
          <br />
          <br />
        </>
      ),
    },
    componentPath: routes.updateContactInformation,
  },
};
